import {useTranslation} from 'react-i18next';
import {Dropzone} from 'components/Dropzone';
import {FormShell} from 'components/form/FormShell';
import {ImageContainer} from 'components/ui/ImageContainer';
import {observer} from 'mobx-react-lite';
import {VehicleState} from 'store/vehicle/VehicleState';

interface VehicleAdditionalPhotosProps {
  state: VehicleState;
}

export const VehicleAdditionalPhotos: React.FC<VehicleAdditionalPhotosProps> = observer(({state}): JSX.Element => {
  const {t} = useTranslation();
  return (
    <FormShell isLoading={state.isLoading}>
      <div>
        <Dropzone
          accept={{
            'image/jpeg': [],
            'image/png': [],
          }}
          multiple={true}
          onDrop={(acceptedFiles: File[]) => state.updateModelFiles(acceptedFiles)}
        />
        <p className="text-darkGray mt-2">{t('Photos for marking damages in reports.')}</p>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {state.item.photos?.modelFiles?.map((image) => (
            <ImageContainer key={image.fileId} image={image} onRemove={() => state.removeModelFile(image.fileId)} />
          ))}
        </div>
      </div>
    </FormShell>
  );
});
